import { AssetsProvider, getHomeUrl } from '@obvio/app'
import { serverClient } from '@obvio/server'
import { NextSeo } from 'next-seo'

import { schema } from '@/api/schema'
import { ARTICLE_SELECT, Post } from '@/components/Blog/Post/Post'
import { Layout } from '@/components/Layout'

import type { PostProps } from '@/components/Blog/Post/Post'
import type {
  GetStaticPathsResult,
  GetStaticPropsContext,
  GetStaticPropsResult,
} from 'next'
import type { ReactElement } from 'react'

export async function getStaticProps(
  ctx: GetStaticPropsContext<{ slug: string }>,
): Promise<GetStaticPropsResult<PostProps>> {
  const client = await serverClient(schema, { isIsr: true, ...ctx })
  const article = await client.query('getArticle', {
    args: {
      slug: ctx.params?.slug ?? '',
    },
    select: ARTICLE_SELECT,
  })

  if (!article) {
    return {
      notFound: true,
    }
  }

  const normalizedArticle = {
    ...article,
    createdAt: article.createdAt.toISOString(),
  }

  return {
    ...client.ssrData({ article: normalizedArticle }),
    revalidate: 180,
  }
}

export async function getStaticPaths(): Promise<GetStaticPathsResult> {
  const client = await serverClient(schema, { isIsr: true })
  const articles = await client.query('getArticles', { select: { slug: true } })

  const slugs = articles.map(({ slug }) => ({ params: { slug } }))

  return {
    paths: slugs,
    fallback: 'blocking',
  }
}

function Page({ article }: PostProps): ReactElement {
  const title =
    article.seoTitle ||
    `${article.title} - Poziom 511 Jura Wellness Hotel & SPA`

  return (
    <AssetsProvider path={`/article/${article.id}`}>
      <NextSeo
        canonical={`${getHomeUrl()}/blog/post/${article.slug}`}
        title={title}
        {...(article.seoDescription && { description: article.seoDescription })}
      />

      <Layout type="Główny">
        <Post article={article} />
      </Layout>
    </AssetsProvider>
  )
}

export default Page
